import {DEBUG, LOG} from "../tools";


export function sendEvent(nameEvent,jsonData){
    if(DEBUG){
        LOG("SEND TAG",nameEvent,jsonData)
    }else{
        window.gtag("event", nameEvent, jsonData)
    }
}